import { IconProps } from "@/src/sb/business-layer/types"

const HamburgerMenu = (props: IconProps) => (
  <svg
    width={props.width ?? props.size ?? 16}
    height={props.height ?? props.size ?? 16}
    viewBox="0 0 28 28"
    fill="none"
  >
    <g clipPath="url(#clip0_28110_135426)">
      <path
        d="M4 21H25V18.6667H4V21ZM4 15.1667H25V12.8333H4V15.1667ZM4 7V9.33333H25V7H4Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_28110_135426">
        <rect
          width="28"
          height="28"
          fill={props.color ?? "white"}
          transform="translate(0.5)"
        />
      </clipPath>
    </defs>
  </svg>
)

export default HamburgerMenu
